import axios from 'axios'

/**
 * A qué backend habla el panel.
 *
 * En la WEB se deja vacío a propósito: así las peticiones van al MISMO dominio
 * desde el que se abrió la página, y nginx las lleva al backend que le
 * corresponde. Es lo que permite que la misma compilación sirva para el CRM
 * personal (mixcrm.alphora.click) y para el SaaS (mixcrm.click) sin que uno
 * acabe consultando la base del otro — que es exactamente lo que pasaba con la
 * URL quemada en .env.production.
 *
 * En la APP MÓVIL no vale: el APK empaqueta la web y la abre desde el propio
 * teléfono, así que no hay "mismo dominio" al que apuntar y hace falta una URL
 * absoluta. Se puede fijar al compilar con REACT_APP_BACKEND_URL; si no, la app
 * va al CRM personal, que es para lo que se usa.
 */
const APP_EMPAQUETADA = typeof window !== 'undefined' &&
  ['capacitor:', 'file:', 'ionic:'].includes(window.location.protocol)

const BACKEND =
  process.env.REACT_APP_BACKEND_URL ||
  (APP_EMPAQUETADA ? 'https://mixcrm.alphora.click'
    : (typeof window !== 'undefined' ? '' : 'http://localhost:3001'))

const api = axios.create({
  baseURL: BACKEND + '/api',
  timeout: 30000,
})

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.clear()
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login'
      }
    }
    return Promise.reject(err)
  }
)

export { BACKEND }
export default api
